import type { AxiosInstance } from 'axios';

import axios from 'axios';

const BASE_URL = process.env.REACT_APP_PRODUCT_API_URI as string;

if (!BASE_URL) {
  throw new Error('REACT_APP_PRODUCT_API_URI is not defined');
}

const apiClient: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;
